const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiBasePath: '/api/',
  apiKey: process.env.REACT_APP_API_KEY,
};

export default config;